// test1188
(1188 && 0);
